import React, { Fragment } from 'react';
import { NonIdealState, Slider } from "@blueprintjs/core";
import logo from '../../../../assets/logo.png'
import { translate } from 'utlis/translations/i18n';

class MultipleChannelVote extends React.Component {
    initializeVotedFor = () => {
        const { votedFor, session, instance, onVote } = this.props;
        const { data } = session;
        const { sequences = [] } = data;
        const currentSequence = sequences[instance.currentSequence];
        const mcCriterias = currentSequence.resources;
        const initialVotedFor = {};

        if (votedFor != null)
            return;
        // The user hasn't voted yet. We initialize the vote to handle
        // the case in which the user is agree with default values
        mcCriterias.map((c) => initialVotedFor[c.id] = 0);
        onVote(initialVotedFor);
    }

    handleChangeSlider = (id, value) => this.props.onVote({ ...this.props.votedFor, [id]: value })

    render() {
        const { session, className, instance, sequences } = this.props;
        const { metadata, data } = session;
        const { mcCriterias = [] } = data;
        let { votedFor = {} } = this.props;
        const currentSequence = sequences[instance.currentSequence];
        const { resources = [] } = currentSequence;

        let firstAttr = 0
        let secondAttr = 0

        if (metadata && metadata.attributes && metadata.attributes.length) {
            metadata.attributes.forEach((attr, i) => {
                resources.forEach((c, index) => {
                    c.attributes = mcCriterias.find(crit => crit.id === c.id).attributes
                    if (i === 0 && c.attributes && c.attributes[i] && c.attributes[i].quantity && votedFor && votedFor[c.id]) {
                        let attriOne = parseFloat(c.attributes[i].quantity) * parseFloat(votedFor[c.id]) / 100
                        firstAttr = attriOne + firstAttr
                    } else if (i === 1 && c.attributes && c.attributes[i].quantity && votedFor && votedFor[c.id]) {
                        let attriTwo = parseFloat(c.attributes[i].quantity) * parseFloat(votedFor[c.id]) / 100
                        secondAttr = attriTwo + secondAttr
                    }
                }
                )
            })
        }

        if (votedFor == null)
            votedFor = {};
        if (mcCriterias.length === 0)
            return (
                <NonIdealState
                    icon="warning-sign"
                    title={translate('noChannels')}
                    description={translate('noChannelsDesc')}
                />
            );
        return (
            <div className={className}>
                <div className="context text-center">
                    <div className='logo-multiple-channel'>
                        <img src={logo} alt="logo" className='logo' />  &nbsp; &nbsp;
                        <span className='logo-title'>VisualSense</span>
                    </div>
                </div>
                <div className="context text-center">
                    {metadata.context}
                </div>
                <br />
                <hr />
                {resources.map((c, index) => (
                    <div key={index} className="margin-top-medium vote-slider margin-bottom-small">
                        <div style={{ fontSize: '16px', fontWeight: "bold" }}>
                            {c.name}
                        </div>
                        <br />
                        <Slider
                            min={0}
                            max={100}
                            value={votedFor[c.id] || 0}
                            stepSize={5}
                            labelStepSize={20}
                            labelRenderer={(value) => `${value}%`}
                            name={c.name}
                            onChange={(value) => this.handleChangeSlider(c.id, value)} />
                        {(metadata && metadata.attributes && metadata.attributes.length) &&
                            metadata.attributes.map((attr, i) => {
                                return (
                                    <div style={{ fontSize: '16px', display: "flex", justifyContent: "space-between", width: "100%" }} key={i}>
                                        <div>{attr.name}:</div>
                                        <div>{c.attributes && (parseFloat(c.attributes[i].quantity) * parseFloat(votedFor[c.id]) / 100).toFixed(2)} {attr.unit}</div>
                                    </div>
                                )
                            }
                            )
                        }
                    </div>
                ))}
                <br />
                <hr />
                <div>

                    {(metadata.attributes && metadata.attributes[0]) &&
                        <Fragment>
                            <h3 className='text-center'>{translate('SUMMARY')}</h3>
                            <div style={{ fontSize: '16px', display: "flex", justifyContent: "space-between", width: "100%", marginBottom: metadata.attributes[1] ? "0px" : "40px", }} >
                                <div>{metadata.attributes[0].name}:</div>
                                <div>{firstAttr.toFixed(2)} {metadata.attributes[0].unit}</div>
                            </div>
                        </Fragment>
                    }
                    {(metadata.attributes && metadata.attributes[1]) &&
                        <div style={{ fontSize: '16px', display: "flex", justifyContent: "space-between", width: "100%", marginBottom: "40px" }} >
                            <div>{metadata.attributes[1].name}:</div>
                            <div>{secondAttr.toFixed(2)} {metadata.attributes[1].unit}</div>
                        </div>
                    }
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.initializeVotedFor();
    }
    componentDidUpdate() {
        this.initializeVotedFor();
    }
}
export default MultipleChannelVote;